"use strict";
(self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || []).push([["shared"],{

/***/ "./js/components/get-oauth.js":
/*!************************************!*\
  !*** ./js/components/get-oauth.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getToken: () => (/* binding */ getToken),
/* harmony export */   isUserLoggedIn: () => (/* binding */ isUserLoggedIn),
/* harmony export */   logout: () => (/* binding */ logout)
/* harmony export */ });
/* unused harmony export loginWithPopup */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _azure_msal_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @azure/msal-browser */ "./node_modules/@azure/msal-browser/dist/app/PublicClientApplication.mjs");
/* harmony import */ var _cart_functions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./cart-functions */ "./js/components/cart-functions.js");



var msalConfig = {};
var isStaging = window.shopifyVariables.isStaging;
var scopeUrl = isStaging ? "https://b2cadaptqaeus2public.onmicrosoft.com/myapp-api/user_impersonation" : "https://b2cadaptprodeus2public.onmicrosoft.com/myapp-api/user_impersonation";
if (isStaging) {
  msalConfig = {
    auth: {
      clientId: "b4a81da9-fbe0-41db-b240-85d3f0316d70",
      // Replace with your Azure B2C App Client ID
      authority: "https://b2cadaptqaeus2public.b2clogin.com/b2cadaptqaeus2public.onmicrosoft.com/B2C_1A_MYAPP_SUSI_USERNAME",
      // Custom Azure B2C policy
      knownAuthorities: ["b2cadaptqaeus2public.b2clogin.com"],
      // Required for B2C
      redirectUri: "https://acho-diabetes.myshopify.com/cart" // Must match registered redirect URI in Azure
    },
    cache: {
      cacheLocation: "localStorage",
      // Store tokens in session storage
      storeAuthStateInCookie: true // Recommended for IE/Edge
    }
  };
} else {
  msalConfig = {
    auth: {
      clientId: "fe1f8382-d53b-4b0d-abbd-6555160a86cd",
      // Replace with your Azure B2C App Client ID
      authority: "https://b2cadaptprodeus2public.b2clogin.com/b2cadaptprodeus2public.onmicrosoft.com/B2C_1A_MYAPP_SUSI_USERNAME",
      // Custom Azure B2C policy
      knownAuthorities: ["b2cadaptprodeus2public.b2clogin.com"],
      // Required for B2C
      redirectUri: "https://acho-diabetes.myshopify.com/cart" // Must match registered redirect URI in Azure
    },
    cache: {
      cacheLocation: "localStorage",
      // Store tokens in session storage
      storeAuthStateInCookie: true // Recommended for IE/Edge
    }
  };
}

// Initialize MSAL instance
var msalInstance = new _azure_msal_browser__WEBPACK_IMPORTED_MODULE_1__.PublicClientApplication(msalConfig);

// Ensure MSAL is initialized before authentication
function initializeMsal() {
  return _initializeMsal.apply(this, arguments);
} // Login request configuration
function _initializeMsal() {
  _initializeMsal = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    '';

    yield msalInstance.initialize();
    console.log("MSAL Initialized");
  });
  return _initializeMsal.apply(this, arguments);
}
var loginRequest = {
  scopes: [scopeUrl]
};
function loginWithPopup() {
  return _loginWithPopup.apply(this, arguments);
}
function _loginWithPopup() {
  _loginWithPopup = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    yield initializeMsal();
    try {
      var _loginResponse$access;
      var loginResponse = yield msalInstance.loginPopup(loginRequest);
      var account = msalInstance.getAllAccounts()[0]; // Get the logged-in user
      if (account) {
        msalInstance.setActiveAccount(account); // ✅ Set the active account
      }
      console.log(loginResponse.accessToken, "Access token");
      return (_loginResponse$access = loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.accessToken) !== null && _loginResponse$access !== void 0 ? _loginResponse$access : null;
    } catch (error) {
      console.error("Authentication failed:", error);
      return null;
    }
  });
  return _loginWithPopup.apply(this, arguments);
}
function handleEmptyTokenLogout() {
  return _handleEmptyTokenLogout.apply(this, arguments);
} // Function to logout
function _handleEmptyTokenLogout() {
  _handleEmptyTokenLogout = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    var _window;
    if ((_window = window) !== null && _window !== void 0 && (_window = _window.auth) !== null && _window !== void 0 && _window.logout) {
      yield window.auth.logout();
      return;
    }
    yield logout();
  });
  return _handleEmptyTokenLogout.apply(this, arguments);
}
function logout(_x) {
  return _logout.apply(this, arguments);
}
function _logout() {
  _logout = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (url) {
    try {
      yield (0,_cart_functions__WEBPACK_IMPORTED_MODULE_2__.removeCartJwtAttribute)();
    } catch (e) {
      console.error("Failed to remove JWT from cart:", e);
    }
    localStorage.clear();
    yield initializeMsal();
    yield msalInstance.logoutPopup();
    window.location.href = url ? url : '/account/logout?return_url=/';
    return true;
  });
  return _logout.apply(this, arguments);
}
function getToken() {
  return _getToken.apply(this, arguments);
}
function _getToken() {
  _getToken = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    yield initializeMsal();
    var account = msalInstance.getActiveAccount();
    if (!account) {
      console.log("No active account, checking all accounts...");
      var accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        account = accounts[0]; // Pick the first available account
        msalInstance.setActiveAccount(account); // ✅ Set the active account
      } else {
        localStorage.clear();
        console.log("No account found. Logging in...");
        var token = yield loginWithPopup();
        if (token) {
          window.azureToken = token;
          yield (0,_cart_functions__WEBPACK_IMPORTED_MODULE_2__.storeCartJwtAttribute)(token);
          if (window.updateLoginStatus) window.updateLoginStatus(true);
          return token;
        }
        yield handleEmptyTokenLogout();
        return null;
      }
    }
    try {
      var tokenResponse = yield msalInstance.acquireTokenSilent({
        scopes: [scopeUrl],
        account: account
      });
      window.azureToken = tokenResponse.accessToken;
      if (window.updateLoginStatus) window.updateLoginStatus(true);
      return tokenResponse.accessToken;
    } catch (error) {
      if (error.name === "InteractionRequiredAuthError") {
        console.warn("Silent authentication failed, prompting login...");
        var _token = yield loginWithPopup();
        if (_token) {
          window.azureToken = _token;
          if (window.updateLoginStatus) window.updateLoginStatus(true);
          return _token;
        }
        yield handleEmptyTokenLogout();
      }
      console.error("Token request failed:", error);
      return null;
    }
  });
  return _getToken.apply(this, arguments);
}
function isUserLoggedIn() {
  return _isUserLoggedIn.apply(this, arguments);
}
function _isUserLoggedIn() {
  _isUserLoggedIn = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    yield initializeMsal();
    var account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    return !!account;
  });
  return _isUserLoggedIn.apply(this, arguments);
}

/***/ }),

/***/ "./js/components/react-wrapper.js":
/*!****************************************!*\
  !*** ./js/components/react-wrapper.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_dom_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-dom/client */ "./node_modules/react-dom/client.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_3__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((Component, container, propsEl) => {
  //component is a pre-compiled class
  //container is where you want to inject component
  //propEl pass prop when injecting
  var appContainer = document.querySelectorAll(container);
  var singlePropsEl = document.querySelector(propsEl);
  var props = {};
  if (singlePropsEl) {
    props = json_6__WEBPACK_IMPORTED_MODULE_3___default().parse(singlePropsEl === null || singlePropsEl === void 0 ? void 0 : singlePropsEl.innerHTML) || {};
  }
  return [...appContainer].map(appTarget => {
    var initialized = appTarget.dataset.initialized || false;
    if (appTarget && !initialized) {
      if (!singlePropsEl) {
        if (propsEl) {
          var _appTarget$querySelec;
          props = {};
          props = json_6__WEBPACK_IMPORTED_MODULE_3___default().parse((_appTarget$querySelec = appTarget.querySelector(propsEl)) === null || _appTarget$querySelec === void 0 ? void 0 : _appTarget$querySelec.innerHTML) || {}; //get json from the script id 
        }
      }
      appTarget.dataset.initialized = true;
      var root = (0,react_dom_client__WEBPACK_IMPORTED_MODULE_2__.createRoot)(appTarget);

      // Store the root reference for potential re-renders
      appTarget._reactRoot = root;

      // Initial render
      root.render(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(Component, {
        shopifyData: props
      }));

      // Listen for cart form updates
      appTarget.addEventListener('cartFormUpdate', event => {
        var newProps = _objectSpread(_objectSpread({}, props), event.detail);
        root.render(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(Component, {
          shopifyData: newProps
        }));
      });
      return root;
    }
  });
});

/***/ }),

/***/ "./js/components/react/api-integration.js":
/*!************************************************!*\
  !*** ./js/components/react/api-integration.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getPatient: () => (/* binding */ getPatient),
/* harmony export */   loginToShopify: () => (/* binding */ loginToShopify),
/* harmony export */   recoverEmail: () => (/* binding */ recoverEmail),
/* harmony export */   updateMultipasstoken: () => (/* binding */ updateMultipasstoken),
/* harmony export */   updatePatient: () => (/* binding */ updatePatient)
/* harmony export */ });
/* unused harmony export getMultipasstoken */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
/* harmony import */ var _get_oauth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../get-oauth */ "./js/components/get-oauth.js");
/* harmony import */ var _idbHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./idbHelpers */ "./js/components/react/idbHelpers.js");





// Create an Axios instance
var apiClient = axios__WEBPACK_IMPORTED_MODULE_1__["default"].create({
  baseURL: window.shopifyVariables.isStaging ? "https://nonprodapi.adapthealth.com/use1/qa/exp/diabetes/v1/api/" : "https://prod.adapthealth.com/diabetes/v1/api/",
  headers: {
    "Content-Type": "application/json"
  }
});

// To fetch token from the API
var getOrRefreshClientToken = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    // Step 1: Check if we have a cached token that hasn't expired
    var token = getCachedToken();
    if (token) {
      // Step 2: Validate the existing cached token
      console.log('Validating cached client token');
      var isValid = yield validateClientToken(token);
      if (isValid) {
        // Token is valid, use it
        console.log('Using validated cached client token');
        return token;
      } else {
        // Token validation failed, clear cache and generate new one
        console.log('Cached token validation failed, generating new token');
        deleteCookie(TOKEN_COOKIE_NAME);
        deleteCookie(TOKEN_EXPIRY_COOKIE_NAME);
        token = null;
      }
    }

    // Step 3: Generate new token (cache expired, missing, or validation failed)
    if (!token) {
      console.log('Generating new client token');
      token = yield generateClientToken();

      // Step 4: Validate the new token before caching
      var _isValid = yield validateClientToken(token);
      if (!_isValid) {
        console.warn('New token validation failed, but caching anyway');
        // Even if validation fails, we'll cache it and let the API calls handle errors
      } else {
        console.log('New token validated successfully');
      }

      // Step 5: Cache the new token
      cacheToken(token);
    }
    return token;
  });
  return function getOrRefreshClientToken() {
    return _ref.apply(this, arguments);
  };
}();

// Add a request interceptor to attach the token and strip phone spaces
apiClient.interceptors.request.use(/*#__PURE__*/function () {
  var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (config) {
    // Strip spaces from phone number fields in request body

    if (config.url.includes('patients/usernamerecovery') || config.url.includes('patients/guest-checkout') || config.url.includes('choice-form')) {
      // For OpenAPI endpoints, use cached client token
      try {
        var _token = yield getOrRefreshClientToken();
        if (_token) {
          config.headers["Authorization"] = "".concat(_token);
          return config;
        } else {
          return Promise.reject(new Error('No access token received'));
        }
      } catch (error) {
        console.error('Error getting token for API call:', error);
        return Promise.reject(new Error('Failed to get authentication token'));
      }
    }

    // For regular API endpoints, use the existing token logic
    var token = yield (0,_get_oauth__WEBPACK_IMPORTED_MODULE_2__.getToken)();
    console.log(token, "----token");
    if (!token) {
      localStorage.clear();
      (0,_idbHelpers__WEBPACK_IMPORTED_MODULE_3__.clearUploadedFilesStore)();
      window.location.reload();
    }
    config.headers["Authorization"] = "Bearer ".concat(token);
    return config;
  });
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}(), error => {
  return Promise.reject(error);
});

// Get multipasstoken API data
var getMultipasstoken = /*#__PURE__*/function () {
  var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (redirectUrl) {
    if (!redirectUrl) return;
    try {
      var response = yield apiClient.get("multipasstoken?redirect_uri=".concat(redirectUrl));
      return response.data;
    } catch (error) {
      return {
        error: true,
        text: error.message
      };
    }
  });
  return function getMultipasstoken(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

// Update multipasstoken API data
var updateMultipasstoken = /*#__PURE__*/function () {
  var _ref4 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    try {
      var response = yield apiClient.put("multipasstoken", body);
      return response.data;
    } catch (error) {
      var _error$response;
      var errorMessage = error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 || (_error$response = _error$response.errorDetails) === null || _error$response === void 0 ? void 0 : _error$response.errorMessage;
      return {
        error: true,
        text: errorMessage
      };
    }
  });
  return function updateMultipasstoken() {
    return _ref4.apply(this, arguments);
  };
}();

// get multipasstoken and login to shopify
var loginToShopify = /*#__PURE__*/function () {
  var _ref5 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (redirectUrl) {
    var forceRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    try {
      if (!window.theme.isCustomer) {
        var _tokenObject$Response;
        var tokenObject = yield getMultipasstoken(redirectUrl);
        var tokenUrl = yield tokenObject === null || tokenObject === void 0 || (_tokenObject$Response = tokenObject.Response) === null || _tokenObject$Response === void 0 ? void 0 : _tokenObject$Response.MultipassTokenURL;
        if (tokenUrl) {
          window.location.href = tokenUrl;
        }
      } else if (forceRedirect) {
        window.location.href = redirectUrl;
      }
      return true;
    } catch (e) {
      return false;
    }
  });
  return function loginToShopify(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

// recover email API method
var recoverEmail = /*#__PURE__*/function () {
  var _ref6 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    try {
      var response = yield apiClient.post("patients/usernamerecovery", body);
      return response.data;
    } catch (error) {
      var _error$response2;
      // Handle different types of errors
      if (error.message && error.message.includes('Authentication failed')) {
        return {
          error: true,
          text: error.message
        };
      }
      var errorMessage = (error === null || error === void 0 || (_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.errorDetails) === null || _error$response2 === void 0 ? void 0 : _error$response2.errorMessage) || error.message || "server error, please try again later!!";
      return {
        error: true,
        text: errorMessage
      };
    }
  });
  return function recoverEmail() {
    return _ref6.apply(this, arguments);
  };
}();

// Get patients details API method
var getPatient = /*#__PURE__*/function () {
  var _ref7 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    try {
      var _response$data;
      console.log('Step: Fetching patients details from /patients API...');
      var response = yield apiClient.get("patients");
      console.log('Step: Successfully fetched patients details', response.data);
      return response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.Response;
    } catch (error) {
      var _error$response3, _error$response4;
      console.error('Step: Error fetching patients details:', error);
      var errorMessage = (error === null || error === void 0 || (_error$response3 = error.response) === null || _error$response3 === void 0 || (_error$response3 = _error$response3.data) === null || _error$response3 === void 0 ? void 0 : _error$response3.text) || (error === null || error === void 0 || (_error$response4 = error.response) === null || _error$response4 === void 0 || (_error$response4 = _error$response4.data) === null || _error$response4 === void 0 || (_error$response4 = _error$response4.errorDetails) === null || _error$response4 === void 0 ? void 0 : _error$response4.errorMessage) || error.message || "server error, please try again later!!";
      return {
        error: true,
        text: errorMessage
      };
    }
  });
  return function getPatient() {
    return _ref7.apply(this, arguments);
  };
}();

// Post entitlements challenge API method
var updatePatient = /*#__PURE__*/function () {
  var _ref8 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    try {
      var response = yield apiClient.post("patients/registeration", body);
      return response.data;
    } catch (error) {
      var _error$response5;
      console.log(error);
      var errorMessage = error === null || error === void 0 || (_error$response5 = error.response) === null || _error$response5 === void 0 || (_error$response5 = _error$response5.data) === null || _error$response5 === void 0 || (_error$response5 = _error$response5.errorDetails) === null || _error$response5 === void 0 ? void 0 : _error$response5.errorMessage;
      return {
        error: true,
        text: errorMessage
      };
    }
  });
  return function updatePatient() {
    return _ref8.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./js/components/react/cart-form.js":
/*!******************************************!*\
  !*** ./js/components/react/cart-form.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ReactComponents_guest_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ReactComponents/guest-form */ "./js/components/react/guest-form.js");
/* harmony import */ var _get_oauth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../get-oauth */ "./js/components/get-oauth.js");
/* harmony import */ var _cart_functions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../cart-functions */ "./js/components/cart-functions.js");
/* harmony import */ var _verify_info_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./verify-info-form */ "./js/components/react/verify-info-form.js");
/* harmony import */ var _api_integration__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./api-integration */ "./js/components/react/api-integration.js");

var _window$Shopify;







var locale = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.locale) === "es" ? "es" : "en";
var getCheckoutUrl = () => {
  var _window$FoxTheme;
  return "".concat(((_window$FoxTheme = window.FoxTheme) === null || _window$FoxTheme === void 0 || (_window$FoxTheme = _window$FoxTheme.routes) === null || _window$FoxTheme === void 0 ? void 0 : _window$FoxTheme.root_url) || "/", "checkout").replace(/\/+/g, "/");
};
var mapStorageToFormData = parsed => {
  var _ref, _parsed$firstName, _ref2, _parsed$lastName, _ref3, _parsed$birthDate, _ref4, _parsed$phoneNumber, _ref5, _parsed$emailId;
  if (!parsed || typeof parsed !== "object") return null;
  return {
    FirstName: (_ref = (_parsed$firstName = parsed.firstName) !== null && _parsed$firstName !== void 0 ? _parsed$firstName : parsed.FirstName) !== null && _ref !== void 0 ? _ref : "",
    LastName: (_ref2 = (_parsed$lastName = parsed.lastName) !== null && _parsed$lastName !== void 0 ? _parsed$lastName : parsed.LastName) !== null && _ref2 !== void 0 ? _ref2 : "",
    DOB: (_ref3 = (_parsed$birthDate = parsed.birthDate) !== null && _parsed$birthDate !== void 0 ? _parsed$birthDate : parsed.DOB) !== null && _ref3 !== void 0 ? _ref3 : "",
    PhoneNumber: (_ref4 = (_parsed$phoneNumber = parsed.phoneNumber) !== null && _parsed$phoneNumber !== void 0 ? _parsed$phoneNumber : parsed.PhoneNumber) !== null && _ref4 !== void 0 ? _ref4 : "",
    EmailAddress: (_ref5 = (_parsed$emailId = parsed.emailId) !== null && _parsed$emailId !== void 0 ? _parsed$emailId : parsed.EmailAddress) !== null && _ref5 !== void 0 ? _ref5 : ""
  };
};
var Loader = _ref6 => {
  var {
    state = false,
    content,
    shouldLogout = false,
    setlogin
  } = _ref6;
  var handleLogout = /*#__PURE__*/function () {
    var _ref7 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      yield (0,_get_oauth__WEBPACK_IMPORTED_MODULE_3__.logout)('/cart');
      if (setlogin) setlogin(false);
    });
    return function handleLogout() {
      return _ref7.apply(this, arguments);
    };
  }();
  if (!state) return null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-w-full tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-[24px]"
  }, state === "error" ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-font-medium tw-text-red-500 tw-text-body tw-px-[24px] lg:tw-px-[32px]"
  }, content), shouldLogout && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    onClick: handleLogout,
    type: "button",
    className: "btn btn--primary"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    class: "btn__text"
  }, "Back to login"))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-relative tw-h-[50px] tw-text-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "loading-overlay !tw-block"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    className: "spinner tw-w-[40px] tw-h-[40px]",
    viewBox: "0 0 66 66"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
    className: "spinner-path",
    fill: "none",
    strokeWidth: "6",
    cx: "33",
    cy: "33",
    r: "30",
    stroke: "#52c3c2"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-font-medium tw-text-body tw-px-[24px] lg:tw-px-[32px]"
  }, content)));
};
var CartForm = () => {
  var [isB2cLogin, setisB2cLogin] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
  var [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [formData, setFormData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
  var [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
  var [shouldShowForm, setShouldShowForm] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var updateLoginStatus = () => {
    setisB2cLogin(true);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (formData !== null) {
      if (formData !== null && formData !== void 0 && formData.FirstName && formData !== null && formData !== void 0 && formData.EmailAddress) {
        if (!window.theme.isCustomer) {
          (0,_api_integration__WEBPACK_IMPORTED_MODULE_6__.loginToShopify)('/cart', true);
        } else {
          setIsLoading(false);
        }
      } else {
        setShouldShowForm(true);
        setIsLoading(false);
      }
    }
  }, [formData]);
  var fetchPatientData = /*#__PURE__*/function () {
    var _ref8 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var response = yield (0,_api_integration__WEBPACK_IMPORTED_MODULE_6__.getPatient)();
        console.log('response----', response);
        if (response !== null && response !== void 0 && response.error && response !== null && response !== void 0 && response.text) {
          var isNotRegistered = String(response.text).toLowerCase().includes("not registered");
          if (isNotRegistered) {
            try {
              var stored = localStorage.getItem("patientDetails");
              var parsed = stored ? JSON.parse(stored) : null;
              var mapped = mapStorageToFormData(parsed);
              setFormData(mapped !== null && mapped !== void 0 ? mapped : {});
            } catch (_unused) {
              setFormData({});
            }
            return null;
          } else {
            setIsLoading(false);
            setFormData({});
            setError({
              text: response.text || "Failed to fetch patient data. Please try again."
            });
            return null;
          }
        }
        var patientDetails = response === null || response === void 0 ? void 0 : response.PatientDetails;
        return patientDetails;
      } catch (err) {
        console.error('Error in fetchPatientData:', err);
        setIsLoading(false);
        setFormData({});
        setError({
          text: (err === null || err === void 0 ? void 0 : err.message) || "Failed to fetch patient data. Please try again."
        });
      }
    });
    return function fetchPatientData() {
      return _ref8.apply(this, arguments);
    };
  }();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    window.updateLoginStatus = updateLoginStatus;
    (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      var b2cLoginStatus = yield (0,_get_oauth__WEBPACK_IMPORTED_MODULE_3__.isUserLoggedIn)();
      setisB2cLogin(b2cLoginStatus);
    })();
    return () => {
      window.updateLoginStatus = null;
    };
  }, []);
  var handleLogin = /*#__PURE__*/function () {
    var _ref0 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (isRegularLogin) {
      if (isRegularLogin) {
        setIsLoading(true);
        var token = yield (0,_get_oauth__WEBPACK_IMPORTED_MODULE_3__.getToken)();
        if (token) {
          try {
            yield (0,_cart_functions__WEBPACK_IMPORTED_MODULE_4__.storeCartJwtAttribute)(token);
            setisB2cLogin(true);
          } catch (e) {
            console.error("Failed to store JWT in cart:", e);
            setIsLoading(false);
          }
        }
      } else {
        setisB2cLogin(false);
        try {
          yield (0,_cart_functions__WEBPACK_IMPORTED_MODULE_4__.removeCartJwtAttribute)();
        } catch (e) {
          console.error("Failed to remove JWT from cart:", e);
        }
        window.location.href = getCheckoutUrl();
      }
    });
    return function handleLogin(_x) {
      return _ref0.apply(this, arguments);
    };
  }();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (isB2cLogin !== null) {
      (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
        if (isB2cLogin) {
          setIsLoading(true);
          var token = yield (0,_get_oauth__WEBPACK_IMPORTED_MODULE_3__.getToken)();
          if (token) {
            yield (0,_cart_functions__WEBPACK_IMPORTED_MODULE_4__.storeCartJwtAttribute)(token);
            var patientDetails = yield fetchPatientData();
            if (patientDetails) {
              localStorage.removeItem("patientDetails");
              setFormData(patientDetails);
            }
          }
        } else {
          yield (0,_cart_functions__WEBPACK_IMPORTED_MODULE_4__.removeCartJwtAttribute)();
          localStorage.removeItem('patientDetails');
        }
      })();
    }
  }, [isB2cLogin]);
  var LoginModal = () => {
    var SVG = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"130\" height=\"130\" viewBox=\"0 0 130 130\" fill=\"none\" class=\"tw-w-[100px] tw-h-[100px]\">\n                        <g clip-path=\"url(#clip0_3769_12831)\">\n                            <path d=\"M74.9016 116.041C49.4432 123.123 22.2851 112.423 8.52003 89.7169C8.08718 89.0032 8.09206 88.1001 8.5528 87.404C14.4858 78.437 24.9886 72.427 35.2634 69.1737C36.1356 68.8976 37.0907 69.197 37.6408 69.9277C45.1484 79.897 58.3986 83.2514 69.5493 78.4833C70.9816 77.8709 72.5735 78.9115 72.5732 80.4693C72.5727 83.097 72.5859 87.8181 72.5748 96.3824C72.5673 102.309 73.8978 107.998 76.2838 113.039C76.8559 114.248 76.1895 115.682 74.9016 116.041Z\" fill=\"#73CECE\"/>\n                            <path d=\"M81.5398 43.328V53.8051C81.5398 66.2018 71.4555 76.2869 59.058 76.2869C46.6803 76.2869 36.5762 66.221 36.5762 53.8051V43.328C36.5762 30.9332 46.6605 20.8462 59.058 20.8462C71.4555 20.8462 81.5398 30.9332 81.5398 43.328Z\" fill=\"#73CECE\"/>\n                            <path d=\"M125.254 71.5899L105.484 66.5952C104.157 66.2593 102.754 66.2593 101.424 66.5952L81.6558 71.5899C78.8686 72.2942 76.9184 74.778 76.9103 77.6411V96.3931C76.8696 112.193 87.5661 125.955 102.921 129.864C103.261 129.953 103.63 129.955 103.978 129.867C119.228 126.086 130.039 112.236 130 96.3985V77.6384C129.992 74.7807 128.042 72.2942 125.254 71.5899ZM115.303 91.6638L103.106 103.861C102.271 104.696 100.9 104.716 100.039 103.861L94.419 98.2404C93.5739 97.3926 93.5739 96.022 94.419 95.1742C95.2668 94.3291 96.6374 94.3291 97.4852 95.1742L101.573 99.2643L112.239 88.5976C113.084 87.7525 114.458 87.7525 115.303 88.5976C116.151 89.4454 116.151 90.816 115.303 91.6638Z\" fill=\"#52C3C2\"/>\n                            <path d=\"M118.006 62.6323C117.925 63.9904 116.627 64.9403 115.308 64.6069C113.009 64.0256 113.204 64.0768 106.545 62.3942C104.522 61.8828 102.385 61.8823 100.364 62.3942L87.1855 65.7239C86.5265 65.8905 86.0755 65.712 85.6494 65.5666C84.5164 65.1803 83.9131 63.9352 84.3167 62.8081C85.3241 59.993 85.8731 56.9633 85.8731 53.8051V43.6698C85.8731 28.9063 74.084 16.6561 59.321 16.5137C44.4139 16.3696 32.2418 28.4537 32.2418 43.3283V53.8053C32.2418 56.9639 32.7908 59.9941 33.7984 62.8092C34.202 63.9365 33.5985 65.1822 32.465 65.5679C23.1629 68.7338 14.0234 73.9423 7.71138 81.3331C6.65284 82.5726 4.64979 82.2145 4.05551 80.6966C-4.11813 59.8229 -0.0521688 34.7361 17.3035 17.3764C40.387 -5.70165 77.7293 -5.7003 100.811 17.3764C113.233 29.8015 118.979 46.3024 118.006 62.6323Z\" fill=\"#B5E5E5\"/>\n                        </g>\n                        <defs>\n                            <clipPath id=\"clip0_3769_12831\">\n                                <rect width=\"130\" height=\"130\" fill=\"white\"/>\n                            </clipPath>\n                        </defs>\n                    </svg>";
    var translations = {
      en: {
        title: "Complete Your Order",
        description: "Please log in to your account to complete your order",
        button: "Login",
        continue_as_guest: "Continue as guest",
        or: "Or"
      },
      es: {
        title: "Completa tu pedido",
        description: "Por favor, inicia sesión en tu cuenta para completar tu pedido",
        button: "Iniciar sesión",
        continue_as_guest: "Continuar como invitado",
        or: "O"
      }
    };
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "tw-w-full row tw-text-center tw-justify-center tw-p-md"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "tw-flex tw-flex-col tw-items-center tw-gap-md tw-self-stretch tw-py-lg md:tw-w-[400px] tw-m-auto"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "login__top-section tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-md tw-self-stretch"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "login__icon tw-w-[100px] tw-h-[100px]",
      dangerouslySetInnerHTML: {
        __html: SVG
      }
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("h2", {
      className: "tw-mb-0 tw-text-h4 body-font",
      style: {
        lineHeight: 1
      }
    }, translations[locale].title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", {
      className: "body-font tw-text-[length:16px] tw-text-s tw-mb-0 tw-mt-xs"
    }, translations[locale].description))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "login__bottom-section tw-flex tw-flex-col tw-items-center tw-gap-sm tw-self-stretch tw-mw-[200px]"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
      onClick: () => handleLogin(true),
      className: "btn btn--primary !tw-cursor-pointer"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
      className: "btn__text"
    }, translations[locale].button)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "tw-text-gray-500 tw-body-font tw-text-s"
    }, translations[locale].or), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
      onClick: () => handleLogin(false),
      className: "btn btn--plain-teal !tw-cursor-pointer"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
      className: "btn__text"
    }, translations[locale].continue_as_guest)))));
  };
  if (isLoading) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "tw-relative tw-h-full tw-min-h-[375px] tw-flex"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(Loader, {
      state: isLoading,
      content: "Fetching patient data...",
      sh: true
    }));
  } else if (error !== null && error !== void 0 && error.text) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "tw-relative tw-h-full tw-min-h-[375px] tw-flex"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(Loader, {
      state: "error",
      content: " Contact our support team for placing the order, with phone number +11234567890",
      shouldLogout: true
    }));
  } else {
    if (!shouldShowForm && (!isB2cLogin || !window.theme.isCustomer)) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
        className: "tw-relative tw-h-full tw-min-h-[375px]"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(LoginModal, null));
    } else if (shouldShowForm) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_verify_info_form__WEBPACK_IMPORTED_MODULE_5__["default"], {
        formData: formData,
        error: error
      });
    } else {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(ReactComponents_guest_form__WEBPACK_IMPORTED_MODULE_2__["default"], null);
    }
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CartForm);

/***/ }),

/***/ "./js/components/react/guest-form.js":
/*!*******************************************!*\
  !*** ./js/components/react/guest-form.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _window$Shopify;

var locale = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.locale) === "es" ? "es" : "en";
var translations = {
  en: {
    amount_due: "Amount due now",
    taxes_note: "Taxes and shipping calculated at checkout",
    checkout: "Checkout"
  },
  es: {
    amount_due: "Monto a pagar ahora",
    taxes_note: "Impuestos y envío calculados al finalizar la compra",
    checkout: "Finalizar compra"
  }
};
var GuestForm = () => {
  var [amountFormatted, setAmountFormatted] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("$0.00 USD");
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var _wrapper$dataset;
    var wrapper = document.querySelector(".cart__login-wrapper");
    var formatted = wrapper === null || wrapper === void 0 || (_wrapper$dataset = wrapper.dataset) === null || _wrapper$dataset === void 0 ? void 0 : _wrapper$dataset.cartTotalFormatted;
    if (formatted) setAmountFormatted(formatted);
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-w-full tw-p-md"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-gap-md"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-justify-between tw-items-baseline tw-gap-xs"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-flex tw-justify-between tw-items-baseline tw-gap-4 tw-w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "body-font tw-text-h6 tw-font-semibold tw-text-[#1a1a1a] tw-tracking-normal"
  }, translations[locale].amount_due), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "body-font tw-text-h6 tw-font-semibold tw-text-[#1a1a1a] tw-whitespace-nowrap tw-tracking-normal"
  }, amountFormatted)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "body-font tw-text-s tw-text-gray-500 tw-tracking-normal tw-m-0"
  }, translations[locale].taxes_note)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: "/checkout",
    className: "btn btn--primary tw-w-full tw-text-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "btn__text"
  }, translations[locale].checkout))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (GuestForm);

/***/ }),

/***/ "./js/components/react/idbHelpers.js":
/*!*******************************************!*\
  !*** ./js/components/react/idbHelpers.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* unused harmony export getFormDataFromIDB */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var idb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! idb */ "./node_modules/idb/build/index.js");


var DB_NAME = "form-file-uploads";
var STORE_NAME = "adapt-health-uploads";
function getDB() {
  return _getDB.apply(this, arguments);
}
function _getDB() {
  _getDB = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    return (0,idb__WEBPACK_IMPORTED_MODULE_1__.openDB)(DB_NAME, 2, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
          console.log("[IndexedDB] Object store '".concat(STORE_NAME, "' created."));
        } else {
          console.log("[IndexedDB] Object store '".concat(STORE_NAME, "' already exists."));
        }
      },
      blocked() {
        console.warn("[IndexedDB] Database open blocked.");
      },
      blocking() {
        console.warn("[IndexedDB] New connection blocked the current one.");
      },
      terminated() {
        console.error("[IndexedDB] Connection unexpectedly closed.");
      }
    });
  });
  return _getDB.apply(this, arguments);
}
function getFormDataFromIDB(_x) {
  return _getFormDataFromIDB.apply(this, arguments);
}
function _getFormDataFromIDB() {
  _getFormDataFromIDB = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (key) {
    return new Promise((resolve, reject) => {
      var request = indexedDB.open(DB_NAME);
      request.onerror = event => {
        console.error("[IndexedDB] Database error:", event.target.errorCode);
        reject('Database error: ' + event.target.errorCode);
      };
      request.onsuccess = event => {
        var db = event.target.result;
        var transaction = db.transaction([STORE_NAME], 'readonly');
        var objectStore = transaction.objectStore(STORE_NAME);
        var getRequest = objectStore.get(key);
        getRequest.onsuccess = () => {
          console.log("[IndexedDB] Retrieved data for key '".concat(key, "':"), getRequest.result);
          resolve(getRequest.result || []);
        };
        getRequest.onerror = () => {
          console.error("[IndexedDB] Error fetching form data from store.");
          reject('Error fetching form data from IndexedDB.');
        };
      };
      request.onsuccess && console.log("[IndexedDB] Database opened successfully.");
    });
  });
  return _getFormDataFromIDB.apply(this, arguments);
}

/***/ }),

/***/ "./js/components/react/phone-validation.js":
/*!*************************************************!*\
  !*** ./js/components/react/phone-validation.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   validatePhoneNumber: () => (/* binding */ validatePhoneNumber)
/* harmony export */ });
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! libphonenumber-js */ "./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js");


/**
 * Validates if a phone number is valid and in strict E.164 format
 * E.164 format: +[country code][number] with NO spaces (e.g., +14155552671)
 * 
 * @param {string} phoneNumber - The phone number to validate
 * @returns {boolean} - Returns true if the phone number is valid and in E.164 format
 */
var validatePhoneNumber = phoneNumber => {
  // Basic input validation
  if (!phoneNumber || typeof phoneNumber !== 'string') {
    return false;
  }

  // Trim the input
  var trimmedNumber = phoneNumber.trim();

  // Check if it starts with + (E.164 format requirement)
  if (!trimmedNumber.startsWith('+')) {
    return false;
  }

  // E.164 format does NOT allow spaces
  if (trimmedNumber.includes(' ')) {
    return false;
  }

  // Parse and validate using libphonenumber-js
  var phoneNumberObj = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_0__.parsePhoneNumber)(trimmedNumber);

  // If libphonenumber can't parse it, it's invalid
  if (!phoneNumberObj) {
    return false;
  }

  // Check if the number is valid according to libphonenumber
  if (!phoneNumberObj.isValid()) {
    return false;
  }

  // Ensure the input matches E.164 format exactly
  var e164Format = phoneNumberObj.format('E.164');
  if (trimmedNumber !== e164Format) {
    return false;
  }
  return true;
};

/***/ }),

/***/ "./js/components/react/recovery-form.js":
/*!**********************************************!*\
  !*** ./js/components/react/recovery-form.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var flowbite_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! flowbite-react */ "./node_modules/flowbite-react/dist/esm/index.mjs");
/* harmony import */ var _api_integration__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./api-integration */ "./js/components/react/api-integration.js");
/* harmony import */ var _get_oauth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../get-oauth */ "./js/components/get-oauth.js");
/* harmony import */ var _phone_validation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./phone-validation */ "./js/components/react/phone-validation.js");


var _window$Shopify;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var CustomTextInput = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(flowbite_react__WEBPACK_IMPORTED_MODULE_3__.TextInput, props);
var locale = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.locale) === "es" ? "es" : "en";
var scrollToTop = elId => {
  var element = document.getElementById(elId); // Convert back to match IDs
  if (element) {
    window.scrollTo({
      behavior: "smooth",
      top: "0"
    });
  }
};
var scrollToEl = errors => {
  var firstErrorField = Object.keys(errors)[0];
  var element = document.getElementById(firstErrorField); // Convert back to match IDs
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
    element.focus();
  }
};
var validateDOB = dob => {
  var birthDate = new Date(dob);
  var minAgeDate = getMinimumDate();
  return birthDate <= minAgeDate;
};
var customInputTheme = {
  base: "!tw-flex",
  addon: "!tw-inline-flex !tw-items-center !tw-rounded-l-md !tw-border !tw-border-r-0 !tw-border-gray-300 !tw-bg-gray-200 !tw-px-3 !tw-text-sm !tw-text-gray-900 dark:!tw-border-gray-600 dark:!tw-bg-gray-600 dark:!tw-text-gray-400",
  field: {
    base: "!tw-relative !tw-w-full",
    icon: {
      base: "tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 tw-pr-3"
    },
    input: {
      base: "!tw-w-full !tw-mb-0 !tw-border !tw-rounded-md !tw-px-4 !tw-py-2 !tw-text-sm !tw-w-full !tw-outline-none focus:!tw-border-black focus:!tw-ring-1 focus:!tw-ring-black ",
      colors: {
        gray: "!tw-border-gray-300 !tw-bg-white !tw-text-black",
        error: "!tw-border-red-500 !tw-bg-red-50",
        success: "!tw-border-green-500 !tw-bg-green-50"
      }
    }
  }
};
var labelTheme = {
  root: {
    base: "!tw-text-base !tw-font-medium",
    colors: {
      default: "!tw-text-[#252525]",
      info: "!tw-text-cyan-500 dark:!tw-text-cyan-600",
      failure: "!tw-text-red-700 dark:!tw-text-red-500",
      warning: "!tw-text-yellow-500 dark:!tw-text-yellow-600",
      success: "!tw-text-green-500"
    }
  }
};
var customTheme = {
  textInput: customInputTheme,
  label: labelTheme
};
var Loader = _ref => {
  var {
    state = false,
    text
  } = _ref;
  return state ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-relative tw-py-10"
  }, state === "error" ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-font-medium tw-text-red-500 tw-text-lg"
  }, text) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement((react__WEBPACK_IMPORTED_MODULE_2___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-relative tw-h-[50px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "loading-overlay !tw-block"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "presentation",
    className: "spinner",
    viewBox: "0 0 66 66"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("circle", {
    className: "spinner-path",
    fill: "none",
    strokeWidth: "6",
    cx: "33",
    cy: "33",
    r: "30",
    stroke: "var(--color-accent)"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-font-medium tw-text-lg tw-animate-pulse tw-text-center"
  }, text, text.includes('not registered') && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-text-xs tw-text-[var(--button-bg-color]",
    onClick: _get_oauth__WEBPACK_IMPORTED_MODULE_5__.getToken
  }, "click here to register")))) : null;
};
var RecoveryForm = () => {
  var [formValues, setFormValues] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
    first_name: "",
    last_name: "",
    email: "",
    dob: "",
    phone_number: ""
  });
  var [errors, setErrors] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
  var [isFormValid, setIsFormValid] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var [prefilledValues, setPrefilledValues] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
  var [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
    state: "error",
    content: "Content"
  });
  var updateLoading = (state, content) => {
    setIsLoading({
      state,
      content
    });
  };
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if ((isLoading === null || isLoading === void 0 ? void 0 : isLoading.state) == "error") {
      scrollToEl({
        "userDataError": true
      });
    } else {
      scrollToTop("recovery-wrapper");
    }
  }, [isLoading]);
  var translations = {
    en: {
      text_first_name: "First name",
      text_last_name: "Last name",
      text_email: "Email",
      text_dob: "Date of Birth",
      text_phone_number: "Phone Number",
      text_valid_phone_number: "Please enter a valid phone number with country code (for eg: +1XXXXXXX) with country code",
      submit: "Submit",
      text_back_to_login: "Register",
      heading: "Recover Username"
    },
    es: {
      text_first_name: "Nombre",
      text_last_name: "Apellido",
      text_email: "Correo electrónico",
      text_dob: "Fecha de nacimiento",
      text_phone_number: "Número de teléfono",
      text_valid_phone_number: "Por favor, ingrese un número de teléfono válido",
      submit: "soumettre",
      text_back_to_login: "registre",
      heading: "Récupérer le nom d'utilisateur"
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var isValid = true;
    ["first_name", "last_name", "email", "dob", "phone_number"].forEach(field => {
      var _formValues$field;
      if (!((_formValues$field = formValues[field]) !== null && _formValues$field !== void 0 && _formValues$field.trim())) {
        isValid = false;
      }
      if (formValues.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)) {
        isValid = false;
      }
      if (!(0,_phone_validation__WEBPACK_IMPORTED_MODULE_6__.validatePhoneNumber)(formValues.phone_number)) {
        isValid = false;
      }
    });
    setIsFormValid(isValid);
  }, [formValues]);
  var handleChange = e => {
    setFormValues(_objectSpread(_objectSpread({}, formValues), {}, {
      [e.target.name]: e.target.value
    }));
    var id = e.target.id;
    if (errors[id] && id != "phone_number" && id !== "dob") {
      var updatedErrors = _objectSpread({}, errors);
      delete updatedErrors[id];
      setErrors(updatedErrors);
    }
    if (id == "phone_number") {
      var isValid = (0,_phone_validation__WEBPACK_IMPORTED_MODULE_6__.validatePhoneNumber)(e.target.value);
      if (!isValid) {
        var newErrors = _objectSpread({}, errors);
        newErrors[id] = translations[locale].text_valid_phone_number;
        setErrors(_objectSpread({}, newErrors));
      } else {
        var _newErrors = _objectSpread({}, errors);
        delete _newErrors[id];
        setErrors(_objectSpread({}, _newErrors));
      }
    }
    if (id == "dob") {
      var _isValid = validateDOB(e.target.value);
      if (!_isValid) {
        var _newErrors2 = _objectSpread({}, errors);
        _newErrors2[id] = translations[locale].text_dob;
        setErrors(_objectSpread({}, _newErrors2));
      } else {
        var _newErrors3 = _objectSpread({}, errors);
        delete _newErrors3[id];
        setErrors(_objectSpread({}, _newErrors3));
      }
    }
  };
  var handleSubmit = e => {
    e.preventDefault();
    var newErrors = {};
    var isValid = true;
    ["first_name", "last_name", "email", "dob", "phone_number"].forEach(field => {
      var _formValues$field2;
      if (!((_formValues$field2 = formValues[field]) !== null && _formValues$field2 !== void 0 && _formValues$field2.trim())) {
        newErrors[field] = "This field is required.";
        isValid = false;
      }
      if (formValues.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)) {
        newErrors.email = "Please enter a valid email address.";
        isValid = false;
      }
      if (!(0,_phone_validation__WEBPACK_IMPORTED_MODULE_6__.validatePhoneNumber)(formValues.phone_number)) {
        newErrors.phone_number = translations[locale].text_valid_phone_number;
        isValid = false;
      }
      setErrors(newErrors);
    });
    if (isValid) {
      (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
        scrollToTop('recovery-wrapper');
        updateLoading(true, 'Validating info...');
        var curatedFormData = {
          "birthDate": formValues === null || formValues === void 0 ? void 0 : formValues.dob,
          "phoneNumber": formValues === null || formValues === void 0 ? void 0 : formValues.phone_number,
          "firstName": formValues === null || formValues === void 0 ? void 0 : formValues.first_name,
          "lastName": formValues === null || formValues === void 0 ? void 0 : formValues.last_name,
          "email": formValues === null || formValues === void 0 ? void 0 : formValues.email
        };
        var res = yield (0,_api_integration__WEBPACK_IMPORTED_MODULE_4__.recoverEmail)(curatedFormData);
        if (res !== null && res !== void 0 && res.error) {
          updateLoading("error", res === null || res === void 0 ? void 0 : res.info);
        } else {
          updateLoading(false, '');
        }
      })();
      return isValid;
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    updateLoading(false, '');
  }, [formValues]);
  var formatDate = dateString => {
    var date = new Date(dateString ? dateString : '');
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    var day = String(date.getDate()).padStart(2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day);
  };
  var getMinimumDate = () => {
    var today = new Date();
    var minAgeDate = new Date();
    minAgeDate.setFullYear(today.getFullYear() - 16);
    console.log(minAgeDate, "min age date");
    return minAgeDate;
  };
  return (isLoading === null || isLoading === void 0 ? void 0 : isLoading.state) == true ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    id: "userDataError"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(Loader, {
    state: isLoading.state,
    text: isLoading.content
  })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-max-w-full md:tw-max-w-[75%] tw-bg-white tw-mx-auto tw-py-10",
    id: "recovery-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h2", {
    className: "tw-text-3xl tw-font-medium tw-mb-4 md:tw-mb-6 "
  }, translations[locale].heading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("form", {
    id: "login-form",
    className: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-5 tw-gap-y-7",
    onSubmit: handleSubmit
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("label", {
    htmlFor: "first_name",
    className: "tw-block tw-font-medium"
  }, translations[locale].text_first_name, " ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-text-[var(--red-300)]"
  }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(CustomTextInput, {
    id: "first_name",
    name: "first_name",
    placeholder: translations[locale].text_first_name,
    value: formValues.first_name,
    onChange: handleChange,
    disabled: !!prefilledValues.first_name
  }), errors.first_name && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-red-500 tw-text-xs italic tw-pt-[5px]"
  }, errors.first_name)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("label", {
    htmlFor: "last_name",
    className: "tw-block tw-font-medium"
  }, translations[locale].text_last_name, " ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-text-[var(--red-300)]"
  }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(CustomTextInput, {
    id: "last_name",
    name: "last_name",
    placeholder: translations[locale].text_last_name,
    value: formValues.last_name,
    onChange: handleChange,
    disabled: !!prefilledValues.last_name
  }), errors.last_name && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-red-500 tw-text-xs italic tw-pt-[5px]"
  }, errors.last_name)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("label", {
    htmlFor: "email",
    className: "tw-block tw-font-medium"
  }, translations[locale].text_email, " ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-text-[var(--red-300)]"
  }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(CustomTextInput, {
    id: "email",
    name: "email",
    type: "email",
    placeholder: translations[locale].text_email,
    value: formValues.email,
    onChange: handleChange,
    disabled: !!prefilledValues.email
  }), errors.email && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-red-500 tw-text-xs italic tw-pt-[5px]"
  }, errors.email)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("label", {
    htmlFor: "dob",
    className: "tw-block tw-font-medium"
  }, translations[locale].text_dob, " ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-text-[var(--red-300)]"
  }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(CustomTextInput, {
    id: "dob",
    name: "dob",
    type: "date",
    max: formatDate(getMinimumDate()),
    value: formValues.dob,
    onChange: handleChange,
    disabled: !!prefilledValues.dob
  }), errors.dob && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-red-500 tw-text-xs italic tw-pt-[5px]"
  }, errors.dob)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("label", {
    htmlFor: "phone_number",
    className: "tw-block tw-font-medium"
  }, translations[locale].text_phone_number, " ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-text-[var(--red-300)]"
  }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(CustomTextInput, {
    id: "phone_number",
    name: "phone_number",
    type: "tel",
    value: formValues.phone_number,
    onChange: handleChange,
    disabled: !!prefilledValues.phone_number
  }), errors.phone_number && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-red-500 tw-text-xs italic tw-pt-[5px]"
  }, errors.phone_number))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-col-span-3 tw-flex tw-flex-col tw-justify-between tw-pt-6 tw-flex-wrap xs:tw-flex-nowrap tw-gap-[20px]"
  }, isLoading.state == "error" && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    id: "userDataError",
    className: " tw-flex tw-gap-1 tw-items-end tw-text-sm tw-text-red-500 tw-font-bold "
  }, isLoading.content, " ", isLoading !== null && isLoading !== void 0 && isLoading.content.includes("not registered") ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-cursor-pointer tw-inline-block tw-text-[var(--button-bg-color)]",
    onClick: _get_oauth__WEBPACK_IMPORTED_MODULE_5__.getToken
  }, "Click here to Register") : ''), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex-col tw-flex md:tw-flex-row tw-gap-2 "
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    form: "login-form",
    type: "submit",
    disabled: !isFormValid,
    className: " tw-w-full md:tw-w-fit md:tw-min-w-[200px] tw-text-white tw-px-6 tw-py-3.5 tw-rounded tw-shadow-md ".concat(isFormValid ? "tw-bg-[var(--button-bg-color)] tw-hover:bg-teal-600" : "tw-bg-gray-400 tw-cursor-not-allowed")
  }, translations[locale].submit)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "form-contact-support"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-lg"
  }, "Please call our support team at ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-font-bold"
  }, "1-800-423-0896"), " for assistance."))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (() => {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(flowbite_react__WEBPACK_IMPORTED_MODULE_3__.Flowbite, {
    theme: {
      theme: customTheme
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(RecoveryForm, null));
});

/***/ }),

/***/ "./js/components/react/verify-info-form.js":
/*!*************************************************!*\
  !*** ./js/components/react/verify-info-form.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _phone_validation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./phone-validation */ "./js/components/react/phone-validation.js");
/* harmony import */ var _api_integration__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./api-integration */ "./js/components/react/api-integration.js");


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var INITIAL_FORM_DATA = patientData => ({
  firstName: (patientData === null || patientData === void 0 ? void 0 : patientData.FirstName) || "",
  lastName: (patientData === null || patientData === void 0 ? void 0 : patientData.LastName) || "",
  birthDate: (patientData === null || patientData === void 0 ? void 0 : patientData.DOB) || "",
  phoneNumber: (patientData === null || patientData === void 0 ? void 0 : patientData.PhoneNumber) || "",
  emailId: (patientData === null || patientData === void 0 ? void 0 : patientData.EmailAddress) || ""
});
var handleEmailSubmit = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* (e, formData) {
    e.stopPropagation();
    e.preventDefault();
    var emailError = validateEmail(formData.emailId);
    if (emailError) {
      setError(prev => _objectSpread(_objectSpread({}, prev), {}, {
        email: emailError
      }));
      return;
    }
    setError(prev => _objectSpread(_objectSpread({}, prev), {}, {
      email: ""
    }));
    try {
      var updateResult = yield (0,_api_integration__WEBPACK_IMPORTED_MODULE_4__.updateMultipasstoken)({
        emailId: email
      });
      if (updateResult.error) {
        setError(prev => _objectSpread(_objectSpread({}, prev), {}, {
          email: updateResult.text || "Failed to update email. Please try again."
        }));
        return;
      }
      var redirectSuccess = yield (0,_api_integration__WEBPACK_IMPORTED_MODULE_4__.loginToShopify)('/checkout', true);
      if (!redirectSuccess) {
        setError(prev => _objectSpread(_objectSpread({}, prev), {}, {
          email: "Failed to redirect to checkout. Please try again."
        }));
      }
    } catch (err) {
      setError(prev => _objectSpread(_objectSpread({}, prev), {}, {
        email: "An error occurred. Please try again."
      }));
    }
  });
  return function handleEmailSubmit(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var mapToUpdatePatientPayload = data => {
  var _ref2, _data$firstName, _ref3, _data$lastName, _ref4, _data$birthDate, _ref5, _data$phoneNumber, _ref6, _data$emailId;
  if (!data) return null;
  return {
    firstName: (_ref2 = (_data$firstName = data.firstName) !== null && _data$firstName !== void 0 ? _data$firstName : data.FirstName) !== null && _ref2 !== void 0 ? _ref2 : "",
    lastName: (_ref3 = (_data$lastName = data.lastName) !== null && _data$lastName !== void 0 ? _data$lastName : data.LastName) !== null && _ref3 !== void 0 ? _ref3 : "",
    birthDate: (_ref4 = (_data$birthDate = data.birthDate) !== null && _data$birthDate !== void 0 ? _data$birthDate : data.DOB) !== null && _ref4 !== void 0 ? _ref4 : "",
    phoneNumber: (_ref5 = (_data$phoneNumber = data.phoneNumber) !== null && _data$phoneNumber !== void 0 ? _data$phoneNumber : data.PhoneNumber) !== null && _ref5 !== void 0 ? _ref5 : "",
    emailId: (_ref6 = (_data$emailId = data.emailId) !== null && _data$emailId !== void 0 ? _data$emailId : data.EmailAddress) !== null && _ref6 !== void 0 ? _ref6 : ""
  };
};
var handleFullFormSubmit = /*#__PURE__*/function () {
  var _ref7 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* (e, childFormData) {
    var _e$preventDefault, _e$stopPropagation;
    e === null || e === void 0 || (_e$preventDefault = e.preventDefault) === null || _e$preventDefault === void 0 || _e$preventDefault.call(e);
    e === null || e === void 0 || (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 || _e$stopPropagation.call(e);
    var payload = childFormData ? mapToUpdatePatientPayload(childFormData) : mapToUpdatePatientPayload(formData);
    if (!payload) return;
    try {
      var updateResult = yield (0,_api_integration__WEBPACK_IMPORTED_MODULE_4__.updatePatient)(payload);
      if (updateResult.error) {
        setError(prev => _objectSpread(_objectSpread({}, prev), {}, {
          emailId: updateResult.text || "Failed to update patient data. Please try again."
        }));
        return;
      }
      var redirectSuccess = yield (0,_api_integration__WEBPACK_IMPORTED_MODULE_4__.loginToShopify)('/checkout', true);
      if (!redirectSuccess) {
        setError(prev => _objectSpread(_objectSpread({}, prev), {}, {
          emailId: "Failed to redirect to checkout. Please try again."
        }));
      }
    } catch (err) {
      console.error('Error in handleFullFormSubmit:', err);
      setError(prev => _objectSpread(_objectSpread({}, prev), {}, {
        emailId: (err === null || err === void 0 ? void 0 : err.message) || "An error occurred. Please try again."
      }));
    }
  });
  return function handleFullFormSubmit(_x3, _x4) {
    return _ref7.apply(this, arguments);
  };
}();
var FormInput = _ref8 => {
  var {
    label,
    name,
    value,
    onChange,
    error,
    type = "text",
    placeholder,
    required = false,
    readOnly = false,
    className = "",
    max = ""
  } = _ref8;
  var baseInputClass = readOnly ? "tw-w-full tw-px-[12px] tw-py-[11px] tw-border tw-border-[#62748E] tw-rounded-[12px] tw-bg-[#FFF] tw-text-[#323E46] tw-cursor-not-allowed tw-text-small focus:tw-outline-none" : "tw-w-full tw-px-[12px] tw-py-[11px] tw-border tw-border-solid tw-rounded-[12px] tw-text-small tw-text-[#323E46] focus:tw-outline-[black] focus:tw-ring-2 focus:tw-ring-[#52c3c2] focus:tw-border-transparent ".concat(error ? 'tw-border-red-500 tw-bg-red-50' : 'tw-border-[#62748E] tw-bg-white');
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("label", {
    className: "tw-block tw-text-small tw-font-medium tw-mb-sm tw-text-[#323E46]"
  }, label, " ", required && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-text-red-500"
  }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("input", {
    type: type,
    name: name,
    value: value || "",
    onChange: onChange,
    readOnly: readOnly,
    required: required,
    placeholder: placeholder,
    className: className || baseInputClass,
    style: {
      borderWidth: '1px'
    },
    max: max
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(ErrorMessage, {
    message: error
  }));
};
var ErrorMessage = _ref9 => {
  var {
    message
  } = _ref9;
  if (!message) return null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-text-red-500 tw-text-xs tw-mt-2 tw-flex tw-items-center tw-gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    className: "tw-w-4 tw-h-4",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  })), message);
};
var VerifyInfoForm = _ref0 => {
  var {
    formData: patientData,
    error: fetchedError
  } = _ref0;
  var isNewPatient = !(patientData !== null && patientData !== void 0 && patientData.FirstName) && !(patientData !== null && patientData !== void 0 && patientData.EmailAddress);
  var initialFormData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => INITIAL_FORM_DATA(patientData), [patientData === null || patientData === void 0 ? void 0 : patientData.FirstName, patientData === null || patientData === void 0 ? void 0 : patientData.LastName, patientData === null || patientData === void 0 ? void 0 : patientData.DOB, patientData === null || patientData === void 0 ? void 0 : patientData.PhoneNumber, patientData === null || patientData === void 0 ? void 0 : patientData.EmailAddress]);
  var [formData, setFormData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(() => initialFormData);
  var [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(fetchedError);
  var [isSubmitting, setIsSubmitting] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);

  // Get today's date in YYYY-MM-DD format for date picker max attribute
  var getTodayDate = () => {
    var today = new Date();
    var year = today.getFullYear();
    var month = String(today.getMonth() + 1).padStart(2, '0');
    var day = String(today.getDate()).padStart(2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day);
  };
  var maxDate = getTodayDate();
  var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var validateEmail = emailValue => {
    if (!(emailValue !== null && emailValue !== void 0 && emailValue.trim())) return "Please enter your email address";
    if (!EMAIL_REGEX.test(emailValue)) return "Please enter a valid email address";
    return "";
  };
  var validateField = (fieldName, value) => {
    var trimmedValue = (value === null || value === void 0 ? void 0 : value.trim()) || "";
    switch (fieldName) {
      case 'firstName':
        return !trimmedValue ? "Please enter your first name" : "";
      case 'lastName':
        return !trimmedValue ? "Please enter your last name" : "";
      case 'birthDate':
        return !trimmedValue ? "Please enter your date of birth" : "";
      case 'phoneNumber':
        if (!trimmedValue) {
          return "Please enter your phone number";
        } else if (!(0,_phone_validation__WEBPACK_IMPORTED_MODULE_3__.validatePhoneNumber)(trimmedValue)) {
          return "Please enter a valid phone number in E.164 format (e.g., +14155552671)";
        }
        return "";
      case 'emailId':
        return validateEmail(trimmedValue);
      case 'email':
        return validateEmail(trimmedValue);
      default:
        return "";
    }
  };
  var validateForm = () => {
    var _formData$phoneNumber;
    var newErrors = {};
    var fields = ['firstName', 'lastName', 'birthDate'];
    var messages = {
      firstName: "Please enter your first name",
      lastName: "Please enter your last name",
      birthDate: "Please enter your date of birth"
    };
    fields.forEach(field => {
      var _formData$field;
      if (!((_formData$field = formData[field]) !== null && _formData$field !== void 0 && _formData$field.trim())) {
        newErrors[field] = messages[field];
      }
    });

    // Validate phone number
    if (!((_formData$phoneNumber = formData.phoneNumber) !== null && _formData$phoneNumber !== void 0 && _formData$phoneNumber.trim())) {
      newErrors.phoneNumber = "Please enter your phone number";
    } else if (!(0,_phone_validation__WEBPACK_IMPORTED_MODULE_3__.validatePhoneNumber)(formData.phoneNumber.trim())) {
      newErrors.phoneNumber = "Please enter a valid phone number in E.164 format (e.g., +14155552671)";
    }
    var emailError = validateEmail(formData.emailId);
    if (emailError) newErrors.emailId = emailError;
    return Object.keys(newErrors).length > 0 ? newErrors : null;
  };
  var handleFormFieldChange = (field, value) => {
    setFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [field]: value
    }));
    // Validate field on change and show error if invalid
    var fieldError = validateField(field, value);
    setError(prev => _objectSpread(_objectSpread({}, prev || {}), {}, {
      [field]: fieldError
    }));
  };
  var formFields = [{
    label: "First Name",
    name: "firstName",
    type: "text",
    placeholder: "Enter your first name"
  }, {
    label: "Last Name",
    name: "lastName",
    type: "text",
    placeholder: "Enter your last name"
  }, {
    label: "Date of Birth",
    name: "birthDate",
    type: "date",
    placeholder: "Enter your date of birth"
  }, {
    label: "Phone Number",
    name: "phoneNumber",
    type: "tel",
    placeholder: "Enter your phone number"
  }, {
    label: "Email Address",
    name: "emailId",
    type: "email",
    placeholder: "Enter your email address"
  }];
  var submitForm = /*#__PURE__*/function () {
    var _ref1 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* (e) {
      var _e$preventDefault2;
      e === null || e === void 0 || (_e$preventDefault2 = e.preventDefault) === null || _e$preventDefault2 === void 0 || _e$preventDefault2.call(e);
      setIsSubmitting(true);
      var newErrors = validateForm();
      if (newErrors) {
        setError(newErrors);
        setIsSubmitting(false);
        return;
      }
      if (isNewPatient) {
        try {
          localStorage.setItem("patientDetails", JSON.stringify(formData));
        } catch (storageErr) {
          console.warn("Could not save new patient data to localStorage", storageErr);
        }
        yield handleFullFormSubmit(e, formData);
      } else {
        yield handleEmailSubmit(e, formData);
      }
      setIsSubmitting(false);
    });
    return function submitForm(_x5) {
      return _ref1.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-w-full md:tw-p-lg tw-p-md"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h2", {
    className: "tw-text-h4 tw-font-bold tw-mb-xs tw-text-navy"
  }, "Complete Your Profile"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("p", {
    className: "tw-text-s tw-text-[#323E46] tw-mb-8 tw-mt-0"
  }, !(patientData !== null && patientData !== void 0 && patientData.emailId) ? "Please provide your email address to continue." : "Please fill in all required information to continue."), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-gap-md",
    "data-form": true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-md tw-gap-y-mdlg"
  }, formFields.map(field => {
    var _formData$field$name, _initialFormData$fiel;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(FormInput, {
      key: field.name,
      label: field.label,
      name: field.name,
      type: field.type,
      value: (_formData$field$name = formData[field.name]) !== null && _formData$field$name !== void 0 ? _formData$field$name : "",
      onChange: e => handleFormFieldChange(field.name, e.target.value),
      error: error === null || error === void 0 ? void 0 : error[field.name],
      placeholder: field.placeholder,
      required: true,
      readOnly: !!((_initialFormData$fiel = initialFormData[field.name]) !== null && _initialFormData$fiel !== void 0 && _initialFormData$fiel.trim()),
      max: field.name === 'birthDate' ? maxDate : undefined
    });
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    type: "button",
    disabled: isSubmitting,
    onClick: e => submitForm(e),
    className: "btn btn--primary flex-grow "
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "btn__text"
  }, isSubmitting ? "Submitting..." : "Submit"))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (VerifyInfoForm);

/***/ })

}]);